import { render } from "./DialogMaker.vue?vue&type=template&id=5cd715b5&scoped=true"
import script from "./DialogMaker.vue?vue&type=script&lang=js"
export * from "./DialogMaker.vue?vue&type=script&lang=js"

import "./DialogMaker.vue?vue&type=style&index=0&id=5cd715b5&scoped=true&lang=postcss"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd715b5"]])

export default __exports__